import React from 'react';
import { ArrowRight, Sparkles, Code2, Cpu } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 tech-grid opacity-40"></div>
      
      {/* Floating orbs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass mb-8 animate-fade-in">
          <Sparkles className="w-4 h-4 text-cyan-400" />
          <span className="text-sm text-cyan-400 font-medium">Transforming Ideas Into Digital Excellence</span>
        </div>
        
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 animate-fade-in-up" style={{animationDelay: '0.2s'}}>
          Build The Future
          <br />
          <span className="gradient-text">With GoAppward</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-slate-300 mb-12 max-w-3xl mx-auto animate-fade-in-up" style={{animationDelay: '0.4s'}}>
          Elite software engineering, AI innovation, and strategic IT solutions that propel your business beyond competition.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up" style={{animationDelay: '0.6s'}}>
          <Button 
            size="lg" 
            className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold px-8 py-6 text-lg rounded-xl shadow-lg shadow-cyan-500/50 hover:shadow-cyan-500/70"
            onClick={scrollToContact}
          >
            Start Your Project
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          
          <Button 
            size="lg" 
            variant="outline" 
            className="border-2 border-slate-600 hover:border-cyan-400 text-slate-200 hover:text-cyan-400 font-semibold px-8 py-6 text-lg rounded-xl bg-transparent hover:bg-slate-800/50"
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Explore Services
          </Button>
        </div>
        
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 animate-fade-in" style={{animationDelay: '0.8s'}}>
          <div className="glass rounded-2xl p-6 hover:scale-105 transition-transform">
            <Code2 className="w-8 h-8 text-cyan-400 mb-3 mx-auto" />
            <div className="text-4xl font-bold text-white mb-2">500+</div>
            <div className="text-slate-400">Projects Delivered</div>
          </div>
          
          <div className="glass rounded-2xl p-6 hover:scale-105 transition-transform">
            <Cpu className="w-8 h-8 text-blue-400 mb-3 mx-auto" />
            <div className="text-4xl font-bold text-white mb-2">98%</div>
            <div className="text-slate-400">Client Satisfaction</div>
          </div>
          
          <div className="glass rounded-2xl p-6 hover:scale-105 transition-transform">
            <Sparkles className="w-8 h-8 text-purple-400 mb-3 mx-auto" />
            <div className="text-4xl font-bold text-white mb-2">24/7</div>
            <div className="text-slate-400">Expert Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};